import script from "./List.vue?vue&type=script&lang=ts&setup=true&name=OrderList"
export * from "./List.vue?vue&type=script&lang=ts&setup=true&name=OrderList"

import "./List.vue?vue&type=style&index=0&id=45e2cd54&lang=stylus&scoped=true"

import exportComponent from "/www/wwwroot/home/admin-tmp/node_modules/.store/vue-loader@16.8.3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45e2cd54"]])

export default __exports__